import { UPDATE_OPLOG, RESET_OPLOG, REFRESH_OPLOG } from "../types";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case UPDATE_OPLOG:
      return [...state, action.payload];
    case REFRESH_OPLOG:
      return action.payload;
    case RESET_OPLOG:
      return [];
    default:
      return state;
  }
}
